import React, {Fragment} from "react";
import Link from "./global/Link";
import {NavDropdown} from "react-bootstrap";
import {useMenuItems} from "./_hooks/useMenuItems";

export const Menu = () => {
  const menuItems = useMenuItems('DESKTOP_NAV');
  menuItems[0].children.push({
    id: 100,
    label: 'Rootcamp',
    url: '/rootcamp',
    target: '_self'
  });

  return menuItems ? (
    <ul className="navbar-nav me-lg-auto mb-2 mb-lg-0">
      {menuItems.map((menuItem, index) => {
        const key = menuItem.id + index;

          return menuItem.children.length ?
            <li className="nav-item me-lg-2 me-xl-3" key={key}>
              <NavDropdown className="nav-item-level-1" title={menuItem.label} id={menuItem.id} menuVariant="dark"
                           renderMenuOnMount={true}>
                {menuItem.children && menuItem.children.length > 0 && menuItem.children.map((childrenItem, index) => (
                  <Fragment key={childrenItem.id + index}>
                    <Link key={childrenItem.id + index} className="nav-link nav-link-level-2"
                          to={childrenItem.url}>{childrenItem.label}</Link>
                    {childrenItem.children && childrenItem.children.length > 0 && (
                      <ul className="list-unstyled ps-3 ps-md-4 sub-nav-level-2 mb-lg-1">
                        {childrenItem.children.map((grandChildrenItem, index) => (
                          <li key={grandChildrenItem.id + index}>
                            <Link className="nav-link sub-nav-link"
                                  to={grandChildrenItem.url}>{grandChildrenItem.label}</Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </Fragment>
                ))}
              </NavDropdown>
            </li>
            :
            <li className="nav-item me-lg-4" key={key}>
              <Link className="nav-link" to={menuItem.url} target={menuItem.target}>{menuItem.label}</Link>
            </li>
        }
      )}
    </ul>
  ) : null;
}
